/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { metricsOverviewPageResource } from '@jira/router-resources__performance-metric-overview/src/metricsOverviewPageResource.tsx';
import { globalSettingsPerformanceOverviewRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceOverviewRoute.tsx';
import Overview, { LazyOverview } from './ui/spa/admin-pages/performance/overview/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsPerformanceOverviewRouteEntry: Route = createEntry(
	globalSettingsPerformanceOverviewRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: Overview,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			metricsOverviewPageResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyOverview],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
